import { Zap, Send, Layers, Link2, TrendingUp } from "lucide-react";

export const HERO_IMG =
  "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?auto=format&fit=crop&w=900&h=1100&q=80";

export const STEPS = [
  {
    title: "Pick a template that fits your offer.",
    desc: "Webinar, ebook, free course, video series, consultation — every template is a clean, conversion-tested starting point. Click. You're in.",
    img: "/screenshots/01-templates-gallery.png",
  },
  {
    title: "Name your campaign.",
    desc: "Headline auto-fills from the template you chose, so you never start at a blank page. Tweak the title or hit Create & Edit and move on.",
    img: "/screenshots/02-name-your-page.png",
  },
  {
    title: "Customize without fighting a builder.",
    desc: "Edit on the left, see the page on the right. Drop in a YouTube hero, generate copy with AI, toggle the form fields you want — done in minutes, not hours.",
    img: "/screenshots/03-builder-customize.png",
  },
  {
    title: "Publish a page that actually converts.",
    desc: "Clean. Fast. Mobile-first. Email-required, name and phone optional. The kind of first impression that says \"I'm the real thing.\"",
    img: "/screenshots/04-published-landing.png",
  },
  {
    title: "Deliver instantly with a check-your-email bridge.",
    desc: "The moment they opt in, they land on a delivery page that says \"Check your email\" — and serves your lead magnet inline. No waiting. No broken links. No amateur hour.",
    img: "/screenshots/05-delivery-page.png",
  },
];

export const FEATURES = [
  { icon: Zap, badge: "01", title: "Lead Capture Pages That Don't Embarrass You.",
    desc: "Clean. Fast. Conversion-optimized. Built to make a first impression that says \"I'm the real thing\" — not \"I found a free tool in 2019.\"",
    testid: "feature-pages" },
  { icon: Send, badge: "02", title: "Instant Content Delivery — Any Format.",
    desc: "Text. PDF. YouTube embed. Google Doc. Notion page. Live link. Whatever your content lives in — VibeLead delivers it the moment they opt in. Clean. Automated. Professional.",
    testid: "feature-delivery" },
  { icon: Layers, badge: "03", title: "Built for Value Delivery, List Growth, and Getting Paid.",
    desc: "This isn't just a pretty page. Every element is engineered to convert the curious into subscribers and subscribers into buyers.",
    testid: "feature-built" },
  { icon: Link2, badge: "04", title: "Drop Any Link. Embed Any Content.",
    desc: "YouTube video? Embed it. PDF guide? Attach it. Google Doc? Link it. Notion hub? Connect it. VibeLead doesn't care where your content lives — it delivers it like you built a custom product just for them.",
    testid: "feature-embed" },
  { icon: TrendingUp, badge: "05", title: "Your List Is Your Business.",
    desc: "Traffic rents attention. Your list owns it. VibeLead is the machine that fills it — one beautifully-converted opt-in at a time.",
    testid: "feature-list" },
];

export const TESTIMONIALS = [
  { quote: "I went from a 12% opt-in rate to 34% after switching to VibeLead. Same traffic. Different page.",
    name: "M. Reyes", role: "Newsletter operator" },
  { quote: "I used to send people to a Google Form to opt in. I didn't realize how much that was costing me until I saw what a real lead page looks like.",
    name: "J. Patel", role: "Coach · 8K list" },
  { quote: "Built my first VibeLead page in 11 minutes. Had 40 subscribers in 48 hours.",
    name: "S. Okonkwo", role: "YouTube creator" },
];

export const TIERS = [
  { name: "Prove It To Me First.", price: "$0", cadence: "forever",
    pitch: "5 pages is enough to know. Most people upgrade within a week.",
    cta: "Start Free — No Card Required", href: "/signup", popular: false,
    bullets: ["5 lead capture pages", "All content delivery formats", "Full opt-in and delivery automation", "VibeLead branding"],
    testid: "tier-free" },
  { name: "I'm Building Now.", price: "$27", cadence: "/ month",
    pitch: "Less than one lost subscriber is worth to a serious operator.",
    cta: "Go Pro Monthly", href: "/pricing", popular: false,
    bullets: ["Up to 30 lead pages per month", "Unlimited subscribers", "All delivery formats", "Custom domain", "No VibeLead branding", "Priority support"],
    testid: "tier-monthly" },
  { name: "I'm Not Playing Around.", price: "$89", cadence: "/ year", flag: "THE ONLY LOGICAL CHOICE",
    pitch: "24 cents a day. The people who choose yearly already know.",
    cta: "Lock In $89/Year", href: "/pricing", popular: true,
    bullets: ["Everything in Pro Monthly", "Saves $235 vs monthly", "Lock the price for 12 months"],
    testid: "tier-yearly" },
];
